module.exports = "/_next/static/images/ConnectToLeadingData-ad265e27dd3f78802652a83d93f8db5b.webp";